// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contentContainer":"itemList__contentContainer--3RCFZ","gridContainer":"itemList__gridContainer--2elnT","gridElement":"itemList__gridElement--23m11"};